var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"iconfont",class:_vm.iconName})
}
var staticRenderFns = []

export { render, staticRenderFns }